var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2381"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2381"] = parcelRequire;
}

var $5Fmyj = parcelRequire("5Fmyj");

var $h9NR5 = parcelRequire("h9NR5");

var $7eXHk = parcelRequire("7eXHk");
(0, $h9NR5.gsap).registerPlugin((0, $7eXHk.ScrollTrigger));
function $7c59f4ec4043ce00$export$842c11d0d3857f4d() {
    const sections = document.querySelectorAll(".rg__column");
    sections.forEach((section)=>{
        // get elements for animation
        const imageBlock = section.querySelector(".rg__image");
        const image = section.querySelector(".rg__image img");
        const mask = section.querySelector(".rg__image--mask");
        const text = section.querySelector(".rg__text");
        const textCopy = section.querySelector(".rg__text--copy");
        const textMask = section.querySelector(".rg__text--mask");
        const textP = section.querySelector(".rg__text--copy p");
        // const cursor = document.querySelector(".ball");
        const elems = [
            imageBlock,
            image,
            mask,
            text,
            textCopy,
            textMask,
            textP
        ];
        // reset the intial position
        (0, $h9NR5.gsap).set([
            imageBlock,
            textMask
        ], {
            yPercent: -101
        });
        (0, $h9NR5.gsap).set([
            mask,
            textP
        ], {
            yPercent: 100
        });
        (0, $h9NR5.gsap).set(image, {
            scale: 1.2
        });
        // add event listeners to each section
        section.addEventListener("mouseenter", (e)=>$7c59f4ec4043ce00$var$createHoverReveal(e, ...elems));
        section.addEventListener("mouseleave", (e)=>$7c59f4ec4043ce00$var$createHoverReveal(e, ...elems));
    });
}
function $7c59f4ec4043ce00$var$createHoverReveal(e, imageBlock, image, mask, text, textCopy, textMask, textP) {
    let tl = (0, $h9NR5.gsap).timeline({
        defaults: {
            duration: 1,
            ease: "power4.out"
        }
    });
    if (e.type === "mouseenter") tl.to([
        mask,
        imageBlock,
        textMask,
        textP
    ], {
        yPercent: 0
    }).to(text, {
        y: ()=>-$7c59f4ec4043ce00$var$getTextHeight(textCopy) / 2,
        color: "var(--text-light)"
    }, 0).to(image, {
        duration: 1.1,
        scale: 1
    }, 0);
    else if (e.type === "mouseleave") tl.to([
        mask,
        textP
    ], {
        yPercent: 100
    }).to([
        imageBlock,
        textMask
    ], {
        yPercent: -101
    }, 0).to(text, {
        y: 0,
        color: "var(--text-dark)"
    }, 0).to(image, {
        duration: 1.1,
        scale: 1.2
    }, 0);
    return tl;
}
function $7c59f4ec4043ce00$var$getTextHeight(textCopy) {
    return textCopy.clientHeight;
}


if (null) null.accept();
function $1d573aefa4935566$var$init() {
    // initCursor();
    (0, $5Fmyj.initNav)();
    (0, $7c59f4ec4043ce00$export$842c11d0d3857f4d)();
}
$1d573aefa4935566$var$init();


//# sourceMappingURL=index.045d28e7.js.map
